import React from "react";
import "../../styles/about.css";

import aboutImg from "../../images/about-us.jpg";

const chooseData = [
  {
    icon: "ri-bar-chart-2-line",
    title: "Effective Marketing Strategies",
    desc: "Targeted digital marketing campaigns designed to maximize brand visibility and audience engagement.",
  },

  {
    icon: "ri-team-line",
    title: "Dedicated Client Support",
    desc: "Collaborative approach with constant communication to ensure your marketing goals are met and exceeded.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 Service",
    desc: "Always available to address your marketing needs, campaign management, and performance tracking.",
  },
];

const About = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="about__wrapper">
          <div className="about__content">
            <h6 className="subtitle">Why choose us</h6>
            <h2>Expertise in</h2>
            <h2 className="highlight">Digital Marketing & Advertising</h2>
            <p className="description about__content-desc">
              We provide tailored digital marketing solutions that fit your business's needs and budget. Our focus is on driving results that help your brand grow and succeed in a competitive market.
            </p>

            <div className="choose__item-wrapper">
              {chooseData.map((item, index) => (
                <div className="choose__us-item" key={index}>
                  <span className="choose__us-icon">
                    <i className={item.icon}></i>
                  </span>
                  <div>
                    <h4 className="choose__us-title">{item.title}</h4>
                    <p className="description">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="about__img">
            <img src={aboutImg} alt="About Mass Trading" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
